import { FormControl, InputLabel, MenuItem, Select, useTheme } from '@mui/material';
import { orderBy } from 'lodash';
import { useOrganizationContext } from 'src/context/organization';

export const OrganizationSelector = () => {
  const theme = useTheme();
  const { organizations, selectedOrganizationId, setSelectedOrganization } =
    useOrganizationContext();

  return (
    <FormControl fullWidth>
      <InputLabel id="organization-select-label">Select Organization</InputLabel>
      <Select
        label={'Select Organization'}
        value={selectedOrganizationId || ''}
        onChange={(e) => {
          setSelectedOrganization(e?.target?.value);
        }}
      >
        {orderBy(organizations, 'name')?.map((org) => {
          return (
            <MenuItem key={org?.organization_id} value={org?.organization_id}>
              {org?.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
